import api from "@/services/api.service";

export default {
  name: 'show-duplicate',
  components: {},
  props: {
    caption: {
      type: String,
      default: "Imported Contact list"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contact_data: [],
      ids: [],
      fields: [],
      conflict_data:[],  
      levelDiscription : {'ExachMacth':'','UpdateMatch': '','ConflictMatch': ''},       
      status:'',
      formField:[],     
      errorClass: 'bg-warning',
      successClass: 'bg-success',
      isBusy: true,
      check:[],
      newids:[],
      md:"6",
      md1:"12"
    }
  },
  computed: {

  },
  created() {
    this.getImportedContact();
  },
  mounted () {
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    async getImportedContact() {
      this.fields = [];

      let response = await api.post("admin/duplicate-contact/list", {id : this.$route.params.conflict_id});   
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data.data != "") {  
          //GET ALL HEADERS FROM JSON        
          var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.contact_data)]));     
          columns.map((h) => {
           this.fields.push({key: h})
          });

          this.fields.push({key:'total_score'},{key:'total_waightage'},{key:'total_score_per'},{key:'updates_on'});
          this.status = response.data.status;  
          //Iterate Data
          this.contact_data = JSON.parse(response.data.contact_data);//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
          this.formField = JSON.parse(response.data.contact_data);;//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
          this.conflict_data = JSON.parse(response.data.conflict_data);    
          var cnt = 0;
          for (const k in this.conflict_data) {
              if(this.conflict_data[k].length > 0){
                cnt = cnt + 1;
              }
          } 
          if(cnt == 1){ this.md = '12'; this.md1 = '6';  }
          let check =  JSON.parse(response.data.conflict_data);
          this.checkContact(check);   
        } else {
          this.fields = [];
        }
      }      
      this.isBusy = false;
    },
    toggleModal() {
      if(!this.formField.id){        
          this.makeToast('Please select column','Validation','danger');
          return;
      }
      this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow');

    },
    async edit(){
      if(!this.formField.id){        
        this.makeToast('Please select column','Validation','danger');
        return;
      }
      this.formField.duplicate_contact_id = this.$route.params.conflict_id;
      let response = await api.post('contact/edit-conflict-contact', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
  
      if (response.status == 'success') {
        this.makeToast(response.message, 'Success', 'success', 6000);
        this.$router.push({name: "Duplicate Contact List",params:{ 'id':this.$route.params.id} });      
      } else {
        for (var error in response.errors) {
          this.makeToast(response.errors[error], 'Alert', 'danger');
        }
      }
    },
    async nextCombine(){
      this.formField.duplicate_contact_id = this.$route.params.conflict_id;
      if(this.formField.id != null){
        let response = await api.post('contact/edit-conflict-contact', this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if (response.status == 'success') 
          this.makeToast(response.message, 'Success', 'success', 6000);
      }

      let response = await api.post('admin/duplicate-contact/next-conflict-contact', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
  
          if (response.status == 'success') {
            return this.$router.push({name : "Duplicate Contact Conflict",params: {conflict_id:response.data.id}});
          } else {
            this.makeToast("No contact pending to resolve conflict","Alert","warning",6000);
            this.$router.push({name: 'Duplicate Contact List'});
          }
    },
    async next(){
      this.formField.duplicate_contact_id = this.$route.params.conflict_id;
      let response = await api.post('admin/duplicate-contact/next-conflict-contact', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
  
          if (response.status == 'success') {
            return this.$router.push({name : "Duplicate Contact Conflict",params: {conflict_id:response.data.id}});
          } else {
            this.makeToast("No contact pending to resolve conflict","Alert","warning",6000);
            this.$router.push({name: 'Duplicate Contact List'});
          }
    },
    exactDelete(eid) {
      this.formField.id = eid;
      this.$bvModal
      .msgBoxConfirm("Are you sure want to delete this Contact?")
      .then(value => {
        if (value) {
          this.deletecontact();
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    },
    singleDelete() {
      this.$bvModal
      .msgBoxConfirm("Are you sure want to delete this Contact?")
      .then(value => {
        if (value) {
          this.deletecontact();
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    },
    async deletecontact(){
      // console.log(this.formField.id);
      if(!this.formField.id){        
        this.makeToast('Please select any column','Alert','danger');
        return;
      }
      this.formField.duplicate_contact_id = this.$route.params.conflict_id;

      let response = await api.post('admin/duplicate-contact/delete', this.formField);
      
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
  
      if (response.status == 'success') {
        this.makeToast(response.message, 'Success', 'success', 6000);
        this.getImportedContact();
      } else {
        // this.makeToast("This contact assigned to "+ response, 'Alert', 'danger', 6000)
        // this.getImportedContact();
        for (var error in response.errors) {
          this.makeToast(response.errors[error], 'Alert', 'danger');
        }
      }
    },
    async checkContact(conflict_data){
      if(conflict_data!=null){
        if(conflict_data.ConflictMatch.length > 0)
        conflict_data.ConflictMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.ExactMatch.length > 0)
        conflict_data.ExactMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.LikelyConflictMatch.length > 0)
        conflict_data.LikelyConflictMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.LikelyUpdateMatch.length > 0)
        conflict_data.LikelyUpdateMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.PossibleConflictMatch.length > 0)
        conflict_data.PossibleConflictMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.PossibleUpdateMatch.length > 0)
        conflict_data.PossibleUpdateMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));

        if(conflict_data.UpdateMatch.length > 0)
        conflict_data.UpdateMatch.forEach( function(element) {
          this.ids.push(element.id);
        }.bind(this));
      
        let response = await api.post('admin/duplicate-contact/contactList', { ids: this.ids });
        if(response.data == null){
          this.newids = '';
        }else{
          this.newids = (response.data);
        }
        // console.log(response)
      }
    
      
    }

  }
}


